module.exports = __webpack_public_path__ + "static/img/preview-04.1e6ed50d.webp";